import React, { useEffect, useState } from "react";
import { Form, Input, InputNumber, Select, Button, Card, message, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";
import api from "../../api";

const { Option } = Select;

const DiscountCreate = () => {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async (search = "") => {
    try {
      const response = await api.get("/panel/product", {
        params: {
          search,
          per_page: 10,
          page: 1,
        },
      });
      setProducts(response.data.data);
    } catch (error) {
      message.error("دریافت محصولات با خطا مواجه شد");
    }
  };

  // ارسال فرم ایجاد تخفیف
  const onFinish = async (values) => {
    setLoading(true);
    try {
      await api.post("/panel/discount", values);
      message.success("تخفیف با موفقیت ایجاد شد");
      navigate("/discount");
    } catch (error) {
      message.error("خطا در ایجاد تخفیف");
    } finally {
      setLoading(false);
    }
  };

  // بررسی خطاهای فرم
  const onFinishFailed = (errorInfo) => {
    console.log("خطاهای فرم:", errorInfo);
    message.error("لطفاً فیلدهای ضروری را پر کنید.");
  };

  return (
    <Card>
      <h1 className="text-2xl font-bold mb-6">ایجاد تخفیف جدید</h1>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed} // افزودن onFinishFailed
        initialValues={{
          status: 0, // مقدار پیش‌فرض برای وضعیت
          day: 1, // مقدار پیش‌فرض برای تعداد روز
          percent: 0, // مقدار پیش‌فرض برای درصد تخفیف
          count: 1, // مقدار پیش‌فرض برای تعداد
        }}
      >
        <Form.Item
          name="post_id"
          label="محصول"
          rules={[{ required: true, message: "محصول الزامی است" }]}
        >
          <Select
          allowClear
            showSearch
            placeholder="انتخاب محصول"
            onSearch={fetchProducts}
            filterOption={false}
          >
            {products.map((product) => (
              <Option key={product.id} value={product.id}>
                {product.title}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="title"
              label="عنوان تخفیف"
              rules={[{ required: true, message: "عنوان الزامی است" }]}
            >
              <Input placeholder="عنوان تخفیف" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="code"
              label="کد تخفیف"
              rules={[{ required: true, message: "کد تخفیف الزامی است" }]}
            >
              <Input placeholder="کد تخفیف" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="day"
              label="تعداد روز"
              rules={[{ required: true, message: "تعداد روز الزامی است" }]}
            >
              <InputNumber placeholder="تعداد روز" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="percent"
              label="درصد تخفیف"
              rules={[{ required: true, message: "درصد تخفیف الزامی است" }]}
            >
              <InputNumber placeholder="درصد تخفیف" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="status"
              label="وضعیت"
              rules={[{ required: true, message: "وضعیت الزامی است" }]}
            >
              <Select placeholder="وضعیت">
                <Option value={0}>پیش‌نویس</Option>
                <Option value={1}>منتشر شده</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="count"
              label="تعداد"
              rules={[{ required: true, message: "تعداد الزامی است" }]}
            >
              <InputNumber placeholder="تعداد" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            ایجاد تخفیف
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default DiscountCreate;